import { procurementAPI } from "../../axios";

export const actions = {

    //PrItem
    GetPrItems(context, data){
        return procurementAPI.get(`PrItem/PR/${data}`);
    },
    GetPrItemsSummary(context, data){
        return procurementAPI.get(`PrItem/Summary/${data}`);
    },
    GetReturnedPrItems(context, data){
        return procurementAPI.get(`PrItem/Returned/${data}`);
    },
    GetAvailableAPIs(context, data){
        return procurementAPI.get(`PrItem/Available/${data.cycle}/${data.deliveryUnitId}`);
    },
    GetSinglePrItem(context, data){
        return procurementAPI.get(`PrItem/${data}`);
    },
    UpdatePrItem(context, data){
        return procurementAPI.put(`PrItem/Update/${data.id}`, data.prItemDetails);
    },
    DeletePrItem(context, data){
        return procurementAPI.delete(`PrItem/${data}`);
    },
    CreatePrItem(context, data){
        return procurementAPI.post(`PrItem/Add/${data.deliveryUnitId}`, data);
    },
    CreateMultiplePrItem(context, data){
        return procurementAPI.post(`PrItem/Add/Multiple/${data.deliveryUnitId}/${data.departmentId}/${data.cycle}`, data.prItems);
    },
    ReturnPrItem(context, data){
        return procurementAPI.put(`PrItem/Allow/Edit/${data.id}`, data);
    },
    ResubmitPrItem(context, data){
        return procurementAPI.put(`PrItem/Resubmit/${data}`);
    },
    UpdatePrItemNote(context, data){
        return procurementAPI.put(`PrItem/Update/Note/${data.id}`, data);
    },
    SetParentPrItem(context, data){
        return procurementAPI.put(`PrItem/Set/Parent/${data.prItemId}/${data.parentId}`);
    },
    GetItemByParent(context, data){
        return procurementAPI.get(`PrItem/Parent/${data}`);
    },
    TransferPrItem(context, data){
        return procurementAPI.put(`PrItem/Update/PrId/${data.prItemId}/${data.prId}`);
    },
    GetSummaryPrItem(context, data){
        return procurementAPI.get(`PrItem/Available/Summary/${data.cycle}/${data.deliveryUnitId}/${data.departmentId}`);
    },
    UpdateSomePRItem(context, data) {
        return procurementAPI.put(`PrItem/Update/SomeFields/${data.prId}/${data.apiResourceId}`, data);
    },
    UpdateBidPRItem(context, data) {
        return procurementAPI.post(`PrItem/Update/BidDetails/${data.prItemId}`, data);
    },
}